var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("AprobarCas"),
      _vm._v(" "),
      _c("VerReporte"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("group")]),
          _vm._v(" Lista Personal CAS\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: {
            color: "rgb(77,179,88)",
            dark: "",
            title: "Ver reporte del CAS / ASP-B",
            type: "submit"
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.verReporte()
            }
          }
        },
        [_c("v-icon", [_vm._v("description")])],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return function() {
                    _vm.filterShow = _vm.filterShow ? false : true
                  }.apply(null, arguments)
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("filter_list")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Búsqueda/filtros")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        { attrs: { bottom: "" } },
        [
          _c(
            "v-btn",
            {
              staticClass: "btn-refresh",
              attrs: { slot: "activator" },
              nativeOn: {
                click: function($event) {
                  return _vm.crearActualizarIncrementoSalarial()
                }
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("refresh")])],
            1
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("common.updateList")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { xs12: "" } },
        [
          _c("transition", { attrs: { name: "slide-fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.filterShow,
                    expression: "filterShow"
                  }
                ],
                staticClass: "filter-container"
              },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v("search")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nro. ítem", type: "number" },
                      on: {
                        input: function($event) {
                          return _vm.filterNroItem(_vm.form.nro_item)
                        }
                      },
                      model: {
                        value: _vm.form.nro_item,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nro_item", $$v)
                        },
                        expression: "form.nro_item"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Nombres" },
                      on: {
                        input: function($event) {
                          return _vm.filterNombres(_vm.form.nombres)
                        }
                      },
                      model: {
                        value: _vm.form.nombres,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "nombres", $$v)
                        },
                        expression: "form.nombres"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Ap. paterno" },
                      on: {
                        input: function($event) {
                          return _vm.filterApPaterno(_vm.form.ap_paterno)
                        }
                      },
                      model: {
                        value: _vm.form.ap_paterno,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ap_paterno", $$v)
                        },
                        expression: "form.ap_paterno"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Ap. Materno" },
                      on: {
                        input: function($event) {
                          return _vm.filterApMaterno(_vm.form.ap_materno)
                        }
                      },
                      model: {
                        value: _vm.form.ap_materno,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "ap_materno", $$v)
                        },
                        expression: "form.ap_materno"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Fecha presentación en ASP-B",
                        type: "date"
                      },
                      on: {
                        input: function($event) {
                          return _vm.filterFechaPresentacion(
                            _vm.form.fecha_presentacion
                          )
                        }
                      },
                      model: {
                        value: _vm.form.fecha_presentacion,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_presentacion", $$v)
                        },
                        expression: "form.fecha_presentacion"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Fecha trámite CAS", type: "date" },
                      on: {
                        input: function($event) {
                          return _vm.filterFechaTramite(_vm.form.fecha_tramite)
                        }
                      },
                      model: {
                        value: _vm.form.fecha_tramite,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_tramite", $$v)
                        },
                        expression: "form.fecha_tramite"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Años de calificación a la fecha",
                        type: "number"
                      },
                      on: {
                        input: function($event) {
                          return _vm.filterAnios(_vm.form.anios)
                        }
                      },
                      model: {
                        value: _vm.form.anios,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "anios", $$v)
                        },
                        expression: "form.anios"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Meses de calificación a la fecha",
                        type: "number"
                      },
                      on: {
                        input: function($event) {
                          return _vm.filterMeses(_vm.form.meses)
                        }
                      },
                      model: {
                        value: _vm.form.meses,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "meses", $$v)
                        },
                        expression: "form.meses"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: "Días calificados a la fecha",
                        type: "number"
                      },
                      on: {
                        input: function($event) {
                          return _vm.filterDias(_vm.form.dias)
                        }
                      },
                      model: {
                        value: _vm.form.dias,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "dias", $$v)
                        },
                        expression: "form.dias"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("v-text-field", {
                      attrs: { label: "Estado" },
                      on: {
                        input: function($event) {
                          return _vm.filterEstado(_vm.form.estado)
                        }
                      },
                      model: {
                        value: _vm.form.estado,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "estado", $$v)
                        },
                        expression: "form.estado"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn-filter" },
                  [
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "", small: "" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.recargar()
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _c("v-icon", { attrs: { small: "" } }, [
                              _vm._v("refresh")
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Recargar filtros")])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tooltip",
                      { attrs: { bottom: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { slot: "activator", icon: "" },
                            nativeOn: {
                              click: function($event) {
                                return function() {
                                  _vm.filterShow = false
                                  _vm.recargar()
                                }.apply(null, arguments)
                              }
                            },
                            slot: "activator"
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Cerrar filtros")])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.lista_cas,
                  "no-data-text": _vm.loading
                    ? "Cargando..."
                    : "No se tiene registros",
                  "disable-initial-sort": true,
                  loading: _vm.loading,
                  "no-results-text": "No se encontraron coincidencias",
                  "item-key": "index",
                  search: _vm.filters,
                  "custom-filter": _vm.customFilter,
                  "rows-per-page-items": [20, 40, { text: "Todos", value: -1 }]
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(items) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nro_item))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.nombres))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ap_paterno))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(items.item.ap_materno))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.fecha_presentacion) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.fecha_tramite) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.anios) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.meses) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(items.item.dias) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                items.item.id_estado == 1
                                  ? " "
                                  : items.item.estado
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "nowrap text-xs-center" },
                          [
                            _c(
                              "v-tooltip",
                              { attrs: { bottom: "" } },
                              [
                                items.item.id_estado == 1
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          slot: "activator",
                                          icon: "",
                                          color: "rgb(147,13,242)",
                                          dark: ""
                                        },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.aprobarCas(items.item)
                                          }
                                        },
                                        slot: "activator"
                                      },
                                      [_c("v-icon", [_vm._v("done")])],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", [_vm._v("Aprobar CAS")])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd8c9176", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd8c9176","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/lista_personal_cas/Index.vue
// module id = null
// module chunks = 